import PATH from "constants/path";
import React from "react";
import { ButtonBanner, ChevronRightBrown } from "assets/svg";

const Banner = () => {
  return (
    <>
      <div className="banner position-relative w-100 container-fluid px-0">
        <div className="position-absolute mb-3 bottom-0 start-50 translate-middle-x">
          <a href={PATH.COMMON + PATH.SIGNUP}>
            <ButtonBanner className="svg-button" />
          </a>
        </div>
      </div>
      <div className="text-center my-2 my-md-4">
        <a
          className="fw-700 py-2 fs-16 fs-sm-13 sp-2 sp-sm-1 text-brown"
          href={PATH.FIRST}
        >
          CLAP&WALKとは
          <span className="ms-1">
            <ChevronRightBrown />
          </span>
        </a>
      </div>
    </>
  );
};

export default Banner;
